﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';
import { ActivatedRoute } from '@angular/router';

@Component({
    template: `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class CargarInterHousesUserComponent {


    anio: any;
    
    tabla: Tabla;

    constructor(private route: ActivatedRoute) {
        this.route.queryParams.subscribe(params => {            
            if (params['anio']) {
                this.anio = JSON.parse(params['anio']);
            } else {
                this.anio = (new Date()).getFullYear();
            }            
        });
        this.initTable();
    }

    initTable() {
        this.tabla = {
            titulo: 'InterHouses',
            endPoint: '/rest-api/user/interhouses?anio=' + this.anio,
            editable: true,
            nuevo: true,
            columnas: [
                {
                    name: 'Casa',
                    prop: 'casa',
                    cell: 'nombre',
                    editable: true,
                    casa: true,
                    resizeable: true,
                    sortable: true,
                    width: 200
                },
                {
                    name: 'Año',
                    prop: 'anio',
                    editable: true,
                    resizeable: true,
                    sortable: true,
                    width: 100
                },
                {
                    name: 'Puntos',
                    prop: 'puntos',
                    editable: true,
                    resizeable: true,
                    sortable: true,
                    width: 100
                }
            ]
        };    
    };

}
